export const ToPowIndex = (num: number): number => {
  if (Math.abs(num) >= 1) {
    for (var ii = 0; ii < 10; ii++) {
      if (Math.abs(num) < Math.pow(10, ii)) {
        return ii - 1;
      }
    }
  } else {
    for (var ii = 0; ii < 10; ii++) {
      if (Math.abs(num) < Math.pow(10, ii * -1)) {
        return ii * -1;
      }
    }
  }

  return 0;
};

/**
 *
 */
export const ToValueRoundInternal = (source: number, index: number, isMax: boolean): number => {
  if (source > 0) {
    var powValue = source / Math.pow(10, index);
    if (powValue >= 1) {
      var floorValue = Math.floor(powValue);
      if (isMax) {
        floorValue += 1;
      } else if ((floorValue = powValue)) {
        floorValue -= 1;
      }

      return floorValue * Math.pow(10, index);
    } else {
      return Math.pow(10, index);
    }
  }
  return 0;
};

/**
 * 最大値で値を丸めます。
 * @param source 変換する値。
 * @returns
 */
export const ToValueMaxRound = (source: number): number => {
  var index = ToPowIndex(source);
  if (source >= 0) {
    return ToValueRoundInternal(source, index, true);
  } else {
    return ToValueRoundInternal(source * -1, index, false) * -1;
  }
};

/**
 *  最小値で値を丸めます。
 * @param source 変換する値。
 * @returns
 */
export const ToValueMinRound = (source: number): number => {
  var index = ToPowIndex(source);
  if (source >= 0) {
    return ToValueRoundInternal(source, index, false);
  } else {
    return ToValueRoundInternal(source * -1, index, true) * -1;
  }
};
